import Joi, { number } from '@hapi/joi'

export const estatePackageCreationSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Group cannot have invalid characters`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Estate cannot have invalid characters`,
        "any.required": `Estate required`
    }),
    collectionPointID: Joi.number().invalid(0).required().label("Division").messages({
        "any.invalid": `Division cannot have invalid characters`,
        "any.required": `Division required`
    }),
    aspNetUserId: Joi.number().label("User").messages({
        "any.invalid": `User cannot have invalid characters`,
        "any.required": `User required`
    }),
    operationalCardID: Joi.number().invalid(0).required().label("Operation Card").messages({
        "any.invalid": `Operation Card cannot have invalid characters`,
        "any.required": `Operation Card required`
    }),
    packageCode: Joi.string().required().min(2).max(2).label("Package Code").regex(/^\w+(?:\s+\w+)*$/).messages({
        "string.empty": `Package Code required`,
        "string.pattern.base": `Package Code cannot have invalid characters`,
        "string.min": `Please enter {#limit} digit number`,
        "string.max": `Please enter {#limit} digit number`
    }),
    packageName: Joi.string().required().label("Package Name").regex(/^(?!\s*$).+/).messages({
        "string.empty": `Package Name required`,
        "string.pattern.base": `Please enter valid estatePackage name`,
    }),
    noOfSessions: Joi.number().min(1).max(9).required().label("No of sessions").messages({
        "number.empty": `No of sessions required`,
        "string.min": `No of sessions should be greater than 0`,
        "string.max": `No of sessions should be less than 10`,
    }),
    backupLoginPassword:Joi.string().required().label("Backup login Password").regex(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/).messages({
        "string.pattern.base": `"Invalid Password"`,
        "string.empty": `Backup Login Password Required`,
    }),
    isActive: Joi.boolean().label("Active"),
    removeUser: Joi.boolean().label("Remove User"),
    edit: Joi.boolean()
}

export const estatePackageCreationFilteringSchema = {

    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Please Select the Group `,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Please Select the Estate`,
        "any.required": `Estate required`
    }),
    collectionPointID: Joi.number().invalid().required().label("Division").messages({
        "any.invalid": `Please Select the Division`,
        "any.required": `Division required`
    }),

}